<div class="jumbotron__tools container mx-auto mt-10 mb-5 md:mb-20 ">
  <div class="jumbotron__header mb-6" [ngClass]="textAlignment">
    <h2 class="jumbotron__name" [translate]="pageInfo.jumbotronTitle || pageInfo.title"></h2>
    @if (pageInfo.description) {
    <p class="jumbotron__desc" [translate]="pageInfo.description"></p>
    } @else {
    @for (description of pageInfo.descriptions; track $index) {
    <p class="jumbotron__desc" [translate]="description"></p>
    }
    }
  </div>

  <!--Features-->
  @if (pageInfo.futures?.length) {
  <div class="jumbotron__content">
    <p class="jumbotron__feature" *ngFor="let feature of pageInfo.futures" [translate]="feature"></p>
  </div>
  }

  <div *ngIf="latestUpdate" class="latest__update">
    {{ "Last Update" | translate }}
    {{ latestUpdate | date: "medium" }}
  </div>

  <div class="contact__social flex gap-4">
    <div *ngFor="let icon of icons">
      @if (icon.insideRouter) {
      <a [routerLink]="icon.path">
        <img [src]="icon.icon" />
      </a>
      } @else {
      <a [href]="icon.path">
        <img [src]="icon.icon" />
      </a>
      }
    </div>
  </div>
</div>